// tech-debt: The step ID is used as label.
import type { IntlShape } from 'react-intl';

export const getStepLabels = (intl: IntlShape) => ({
  Documents: intl.formatMessage({
    id: 'wizard.step.documents',
    defaultMessage: 'Documents',
    description: 'Label for the Documents step in the wizard',
  }),
  Structure: intl.formatMessage({
    id: 'wizard.step.structure',
    defaultMessage: 'Structure',
    description: 'Label for the Structure step in the wizard',
  }),
});
